import { apiClient } from './apiClient';
import type {
  Notification,
  NotificationsResponse,
  UnreadCountResponse,
} from '../types/notification.types';

export const notificationsApi = {
  /**
   * Get paginated list of notifications for the current user
   */
  async getNotifications(page = 1, limit = 20): Promise<NotificationsResponse> {
    const response = await apiClient.get<{
      success: boolean;
      data: NotificationsResponse;
    }>('/api/notifications', {
      params: { page, limit },
    });
    return response.data.data;
  },

  /**
   * Get the count of unread notifications
   */
  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get<{
      success: boolean;
      data: UnreadCountResponse;
    }>('/api/notifications/unread-count');
    return response.data.data.count;
  },

  /**
   * Mark a single notification as read
   */
  async markAsRead(id: string): Promise<Notification> {
    const response = await apiClient.patch<{
      success: boolean;
      data: Notification;
    }>(`/api/notifications/${id}/read`, {});
    return response.data.data;
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<void> {
    await apiClient.patch('/api/notifications/read-all', {});
  },
};
